import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import './front-statistics.scss';
window.addEventListener( 'load', function () {
	const carousels = document.querySelectorAll( '.statistics-carousel' );
	const statisticsWrapper = document.querySelectorAll(
		'.statistics-wrapper'
	);

	if ( 0 < carousels.length ) {
		Swiper.use( [ Navigation, Scrollbar ] );
		carousels.forEach( function ( carousel ) {
			new Swiper( carousel, {
				slidesPerView: 1.3,
				spaceBetween: 25,
				grid: {
					rows: 2,
					fill: 'row',
				},
				breakpoints: {
					960: {
						slidesPerView: 'auto',
					},
				},
			} );
		} );
	}

	if ( 0 < statisticsWrapper.length ) {
		statisticsWrapper.forEach( function ( wrapper ) {
			const wrapperChild = wrapper.querySelector( '.statistics' );
			wrapper.scrollTop = 0;
			wrapper.scrollLeft = 0;
			const nextBtn = wrapper.parentElement.querySelector( '.next' );
			const prevBtn = wrapper.parentElement.querySelector( '.previous' );
			let pos = { top: 0, left: 0, x: 0, y: 0 };

			if ( wrapper.scrollLeft < 40 ) {
				prevBtn.classList.add( 'disabled' );
			}

			const mouseDownHandler = function ( e ) {
				wrapper.style.userSelect = 'none';

				pos = {
					left: wrapper.scrollLeft,
					top: wrapper.scrollTop,
					// Get the current mouse position
					x: e.clientX,
					y: e.clientY,
				};

				document.addEventListener( 'mousemove', mouseMoveHandler );
				document.addEventListener( 'mouseup', mouseUpHandler );
			};

			const mouseMoveHandler = function ( e ) {
				// How far the mouse has been moved
				const dx = e.clientX - pos.x;
				const dy = e.clientY - pos.y;

				// Scroll the element
				wrapper.scrollTop = pos.top - dy;
				wrapper.scrollLeft = pos.left - dx;
			};

			const mouseUpHandler = function () {
				document.removeEventListener( 'mousemove', mouseMoveHandler );
				document.removeEventListener( 'mouseup', mouseUpHandler );

				wrapper.style.removeProperty( 'user-select' );
			};

			const checkArrowsVisibility = function () {
				if (
					wrapper.scrollLeft + wrapperChild.clientWidth >
					wrapperChild.scrollWidth - 60
				) {
					nextBtn.classList.add( 'disabled' );
				} else {
					nextBtn.classList.remove( 'disabled' );
				}

				if ( wrapper.scrollLeft < 40 ) {
					prevBtn.classList.add( 'disabled' );
				} else {
					prevBtn.classList.remove( 'disabled' );
				}
			};

			nextBtn.addEventListener( 'click', function () {
				wrapper.scrollLeft = wrapper.scrollLeft + 400;
				checkArrowsVisibility();
			} );

			prevBtn.addEventListener( 'click', function () {
				wrapper.scrollLeft = wrapper.scrollLeft - 400;
				checkArrowsVisibility();
			} );

			if ( wrapper.clientWidth < wrapperChild.scrollWidth ) {
				wrapper.classList.add( 'draggable' );
				wrapper.addEventListener( 'mousedown', mouseDownHandler );
			} else {
				nextBtn.classList.add( 'disabled' );
				prevBtn.classList.add( 'disabled' );
			}
		} );
	}
} );
